import React, { useMemo, useState, useRef, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import HeaderPage from './Components/HeaderPage';
import OrderList from '../../components/OrderList';
import CallBell from '../../components/CallBell';
import OrderDetails from './Components/OrderDetails';

import * as styled from './style';

const Home = ({
  isFiltered,
  ordersFiltered,
  subscribeOrdersByStatus,
  searchStatus,
  subscribeOrder,
  merchant,
  orders,
  order,
  idOrderSelected,
  searchOrders,
  ordersLoaded,
  ordersIsFetching,
  orderIsFetching,
  updateEstimatedTimes,
  updateDeliveryPersonally,
  searchHours,
  putOrder,
  getMerchant,
  merchantIsFetching,
  merchantIsUpdating,
  ordersError,
  searchOrdersByStatus,
  searchOrdersByHours,
  selectOrder,
}) => {
  useEffect(() => {
    getMerchant();
  }, []);

  const ordersPending = orders.filter(order => order.status === 20).map(order => order.id);

  const ordersPendingString = JSON.stringify(ordersPending);

  const lastOrdersPendingRef = useRef(ordersPending);
  const [pendingAck, setPendingAck] = useState(ordersPending.length > 0);

  const handleCloseSnackbar = useCallback(() => {
    setPendingAck(false);
  }, []);

  useEffect(() => {
    let isPending = false;
    if (ordersPending.length > lastOrdersPendingRef.current.length) {
      isPending = true;
    } else if (ordersPending.length > 0) {
      for (const orderPending of ordersPending) {
        if (!lastOrdersPendingRef.current.find(lastOrder => lastOrder.id === orderPending.id)) {
          isPending = true;
          break;
        }
      }
    }

    lastOrdersPendingRef.current = ordersPending;
    if (isPending || ordersPending.length === 0) {
      setPendingAck(isPending);
    }
  }, [ordersPending]);

  const [fetchedListOnce, setFetchedListOnce] = useState(false);
  const loadingOrder = useMemo(() => {
    if (order && order.id === idOrderSelected) {
      return false;
    }
    return orderIsFetching;
  }, [orderIsFetching, order, idOrderSelected]);

  const loadingOrders = useMemo(() => {
    if (fetchedListOnce) {
      return false;
    }
    if (!ordersIsFetching) {
      setFetchedListOnce(true);
    }
    return ordersIsFetching;
  }, [ordersIsFetching, fetchedListOnce]);

  return (
    <div>
      <HeaderPage
        merchant={merchant}
        merchantIsFetching={merchantIsFetching}
        merchantIsUpdating={merchantIsUpdating}
        updateTimes={updateEstimatedTimes}
        updateDeliveryPersonally={updateDeliveryPersonally}
      />
      <Snackbar open={pendingAck}>
        <Alert
          icon={<CallBell fontSize="large" paused={!pendingAck} />}
          onClose={handleCloseSnackbar}
          severity="warning"
          style={{ fontSize: 18 }}
        >
          Há{' '}
          {ordersPending.length === 1 ? 'um novo pedido' : `${ordersPending.length} novos pedidos`}
        </Alert>
      </Snackbar>
      <styled.Container>
        <styled.OrderListContainer>
          <OrderList
            isFiltered={isFiltered}
            ordersLoaded={ordersLoaded}
            selectOrder={selectOrder}
            searchOrdersByStatus={searchOrdersByStatus}
            searchOrdersByHours={searchOrdersByHours}
            searchStatus={searchStatus}
            searchHours={searchHours}
            orders={ordersFiltered}
            subscribeOrdersByStatus={subscribeOrdersByStatus}
            searchOrders={searchOrders}
            ordersIsFetching={loadingOrders}
            subscribeOrder={subscribeOrder}
            idOrderSelected={idOrderSelected}
            ordersError={ordersError}
          />
        </styled.OrderListContainer>

        <styled.OrderContainer className="order-container">
          <OrderDetails
            orderIsFetching={loadingOrder}
            ordersIsFetching={loadingOrders}
            order={order}
            putOrder={putOrder}
            merchant={merchant}
          />
        </styled.OrderContainer>
      </styled.Container>
    </div>
  );
};

Home.propTypes = {
  ordersFiltered: PropTypes.array,
  ordersLoaded: PropTypes.bool.isRequired,
  subscribeOrdersByStatus: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool,
  merchant: PropTypes.object,
  searchStatus: PropTypes.object,
  searchHours: PropTypes.object,
  order: PropTypes.object,
  idOrderSelected: PropTypes.number,
  subscribeOrder: PropTypes.func.isRequired,
  putOrder: PropTypes.func.isRequired,
  updateEstimatedTimes: PropTypes.func.isRequired,
  updateDeliveryPersonally: PropTypes.func.isRequired,
  searchOrdersByStatus: PropTypes.func.isRequired,
  searchOrders: PropTypes.func.isRequired,
  getMerchant: PropTypes.func.isRequired,
  selectOrder: PropTypes.func.isRequired,
  ordersIsFetching: PropTypes.bool,
  orderIsFetching: PropTypes.bool,
  merchantIsFetching: PropTypes.bool,
  merchantIsUpdating: PropTypes.bool,
  ordersError: PropTypes.any,
};

Home.defaultProps = {
  ordersFiltered: [],
  order: {},
  searchHours: {},
  searchStatus: {},
  merchant: {},
  ordersIsFetching: false,
  orderIsFetching: false,
  merchantIsFetching: false,
  merchantIsUpdating: false,
  isFiltered: false,
  ordersError: null,
};

export default Home;



// WEBPACK FOOTER //
// ./src/screens/Home/index.js